// shared-бакет не гейтиться за роллю — доступний обом ролям (not-found, ui-kit, checkout).
// Placeholder лише для консистентності зі структурою бакетів.
export const sharedLoader = () => null;
